import { AdminBulkIndexPanel } from '../components/AdminBulkIndexPanel';
import { CommonPackageRequestsPanel } from '../components/RequestPanels';

export function RequestIndexPage({ isAdmin }: { isAdmin: boolean }) {
  return (
    <div className="space-y-6 py-4">
      <div>
        <p className="page-eyebrow">Add to shared context</p>
        <h1 className="page-title mt-2">Index an exact library version</h1>
        <p className="page-lede">
          Choose a trusted registry or a GitHub/GitLab repository, then pin the version or release
          tag. llmcontext records the source and index date so every developer and agent can query
          the same reusable snapshot.
        </p>
      </div>
      <CommonPackageRequestsPanel sectionId="request-package-panel" isAdmin={isAdmin} />
      {isAdmin ? <AdminBulkIndexPanel /> : null}
    </div>
  );
}
